module.exports = __webpack_public_path__ + "img/transfer5.7e8f349f.jpg";